
            const data = {"name":"outline/12/arrow-down","data":{"width":"12","height":"12","viewBox":"0 0 12 12","data":"<path pid=\"0\" _fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m.5 3.5 5.5 6 5.5-6\" class=\"nc-icon-wrapper\" _stroke=\"#272c33\"/>","originalColors":[{"type":"fill","color":"none"},{"type":"stroke","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    